<template>
  <div>
    <div v-if="step === 1" class="add-pipeline-content">
      <horizontal-menu
        class="add-pipeline-menu"
        :menuItems="menuItems"
        :activeMenuItem="subType"
        @onMenuItemChange="handleMenuItemChange"
      />
      <div class="add-pipeline-grid">
        <div
          @click="handleInstallationClick(option.value)"
          :key="option.value"
          v-for="option in options"
          class="add-pipeline-card"
        >
          <img :src="getInstallationImage(option.value)" alt="icon" />
          <p>{{ option.text }}</p>
        </div>
      </div>
      <div class="modal-footer-buttons">
        <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
      </div>
    </div>

    <div v-if="step === 2" class="add-pipeline-form">
      <button class="back-button" @click="step = 1">
        <img class="back-button-icon" src="../../../files/arrow-left-primary.svg" alt="arrow left" /> Назад
      </button>

      <pumpline-liquid
        :saving="saving"
        @create="create($event)"
        :substrate="substrate"
        :substances="substances"
        :pipeline.sync="pipeline"
        :substance="cur_substance"
        @close_window="$emit('close_window')"
        v-if="type == 41 || type == 42"
        :proj_id="proj_id"
        :type="type"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <pumpline-gas
        :saving="saving"
        @create="create($event)"
        :substrate="substrate"
        :substances="substances"
        :pipeline.sync="pipeline"
        :substance="cur_substance"
        @close_window="$emit('close_window')"
        v-if="type == 43"
        :proj_id="proj_id"
        :type="type"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <pipeline-main-gas
        :saving="saving"
        @create="create($event)"
        :substrate="substrate"
        :substances="substances"
        :pipeline.sync="pipeline"
        :substance="cur_substance"
        @close_window="$emit('close_window')"
        v-if="type == 46"
        :proj_id="proj_id"
        :type="type"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />

      <pipeline-main-lpg
        :saving="saving"
        @create="create($event)"
        :substrate="substrate"
        :substances="substances"
        :pipeline.sync="pipeline"
        :substance="cur_substance"
        @close_window="$emit('close_window')"
        v-if="type == 44 || type == 45"
        :proj_id="proj_id"
        :type="type"
        :validator.sync="validator"
        :loadSubstances="loadSubstances"
      />
    </div>
  </div>
</template>

<script>
import { getImage } from "../../../utils/utils";
import HorizontalMenu from "../../../components/HorizontalMenu.vue";
import MainButton from "../../../components/ui/MainButton.vue";
import PumplineLiquid from "../../../components/InstallationForms/PumplineLiquid.vue";
import PumplineGas from "../../../components/InstallationForms/PumplineGas.vue";
import PipelineMainGas from "../../../components/InstallationForms/PipelineMainGas.vue";
import PipelineMainLpg from "../../../components/InstallationForms/PipelineMainLpg.vue";
export default {
  name: "pipeline",
  components: {
    HorizontalMenu,
    MainButton,
    PumplineLiquid,
    PumplineGas,
    PipelineMainGas,
    PipelineMainLpg,
  },
  props: {
    proj_id: [Number, String],
    pipeline: Object,
    pipeline_index: Number,
    substrate: Object,
    showErrors: Function,
  },
  mounted() {
    this.type = this.pipeline.obj_type;
    if (this.pipeline.id) {
      this.step = 2;
    }
  },
  computed: {
    options() {
      switch (this.subType) {
        case "0":
          return [
            {
              value: 41,
              text: "Технологический трубопровод для перекачки ЛВЖ и ГЖ",
            },
            { value: 44, text: "Магистральный трубопровод для перекачки ЛВЖ и ГЖ" },
          ];

        case "1":
          return [
            {
              value: 42,
              text: "Технологический трубопровод для перекачки СУГ/СПГ",
            },
            { value: 45, text: "Магистральный трубопровод для перекачки СУГ/СПГ" },
          ];

        case "2":
          return [
            {
              value: 43,
              text: "Технологический трубопровод для перекачки газа",
            },
            { value: 46, text: "Магистральный трубопровод для перекачки газа" },
          ];
        default:
          return [];
      }
    },
  },
  data() {
    return {
      saving: false,
      step: 1,
      subType: "0",
      substances: [],
      cur_substance: {},
      type: null,
      validator: {},
      menuItems: [
        { text: "Жидкость", menuItem: "0" },
        { text: "СУГ, СПГ", menuItem: "1" },
        { text: "Газ", menuItem: "2" },
      ],
    };
  },
  created() {},
  methods: {
    handleInstallationClick(option) {
      this.step = 2;
      this.type = option;
    },

    handleMenuItemChange(item) {
      this.subType = item;
    },

    create(model) {
      if (!model.id) {
        this.$set(this, "saving", true);
        const data = {};
        Object.assign(data, model);

        data.dots = this.pipeline.dots;
        this.$http
          .post("risk/objects/pipeline-create?proj_id=" + this.proj_id, {
            ...data,
            substance: data.substance ? data.substance.code : null,
            extinguish_system: data.extinguish_system ? data.extinguish_system.code : undefined,
            alarm_system: data.alarm_system ? data.alarm_system.code : undefined,
            underground: data.underground ? Number(data.underground) : 0,
          })
          .then((response) => {
            this.$set(this, "saving", false);
            this.$emit("newObject", response.data);
          })
          .catch((e) => {
            this.$set(this, "saving", false);
            if (e.response.data) {
              this.$set(this, "validator", {});
              this.$set(this, "validator", e.response.data);
            }
          });
      } else {
        this.$set(this, "saving", true);
        const data = {};
        Object.assign(data, model);

        delete data.dots;
        this.$http
          .post("risk/objects/update?proj_id=" + this.proj_id + "&id=" + model.id, {
            ...data,
            substance: data.substance ? data.substance.code : null,
            extinguish_system: data.extinguish_system ? data.extinguish_system.code : undefined,
            alarm_system: data.alarm_system ? data.alarm_system.code : undefined,
            underground: data.underground ? Number(data.underground) : 0,
          })
          .then((response) => {
            this.$set(this, "saving", false);
            Object.assign(this.pipeline, response.data);
            if (response.data.errors) {
              this.showErrors(response.data.errors);
            }
            this.$emit("pipelineWindowClose");
            this.$emit("clearCalculations")
          })
          .catch((e) => {
            this.$set(this, "saving", false);
            if (e.response.data) {
              this.$set(this, "validator", {});
              this.$set(this, "validator", e.response.data);
            }
          });
      }
    },

    loadSubstances(types) {
      this.$http.get("risk/substance/substances?types=" + types).then((response) => {
        this.substances = response.data;
        this.getSubstance();
      });
    },
    getSubstance() {
      if (this.pipeline.substance && typeof this.pipeline.substance !== "object") {
        for (var i in this.substances) {
          var data = this.substances[i].subs.find((cur) => cur.id == this.pipeline.substance);
          if (data) {
            this.cur_substance = data;
          }
        }
      }
    },
    getInstallationImage(image) {
      return getImage(image);
    },
  },
};
</script>

<style scoped>
.add-pipeline-content {
  width: 800px;
}
.add-pipeline-menu {
  margin-top: 0;
}
.add-pipeline-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 32px;
  padding: 0 24px 32px;
}
.add-pipeline-card {
  min-width: 240px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid var(--border-color);
  background: var(--white-color);
  transition: border 0.15s ease-out;
  cursor: pointer;
}
.add-pipeline-card:hover {
  border: 1px solid var(--secondary-color);
}
.add-pipeline-form {
  width: 800px;
}
</style>
